<template>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addDict"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editDict(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteDict(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">

        <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
        <span
          class="icon-box"
          @click="refreshDictList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>

      </div>
    </div>
    <el-table
      :data="dictList"
      height="100%"
      size="small"
      element-loading-background="rgba(245, 245, 245, 0.3)"
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column align="center" type="index" width="55"> </el-table-column> -->
      <el-table-column
        align="center"
        type="selection"
        width="55"
      > </el-table-column>
      <el-table-column
        align="center"
        prop="dictType"
        label="类型"
        width="180"
      > </el-table-column>

      <el-table-column
        align="center"
        prop="dictName"
        label="名称"
      > </el-table-column>

        <el-table-column
            align="center"
            prop="status"
            label="状态"
        >
            <template scope="scope">
                <span v-if="scope.row.status=== 0">禁用</span>
                <span v-else-if="scope.row.status=== 1">正常</span>
            </template>
        </el-table-column>

        <el-table-column
            align="center"
            prop="isShow"
            label="配置"
        >
            <template scope="scope">
                <span v-if="scope.row.isShow=== 0">隐藏</span>
                <span v-else-if="scope.row.isShow=== 1">显示</span>
            </template>
        </el-table-column>

        <el-table-column
            align="center"
            prop="sort"
            label="排序"
        > </el-table-column>

        <el-table-column
            align="center"
            prop="remarks"
            label="备注"
        > </el-table-column>

      <el-table-column
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkDict(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span
                class="operation-label"
              >查看</span>
            </div>
            <div @click="editDict(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span
                class="operation-label"
              >修改</span>
            </div>
            <div @click="deleteDict(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span
                class="operation-label"
                style="color: red"
              >删除</span>
            </div>
            <div @click="getDictValue(scop.row.id,scop.row.dictType)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">管理键值</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改字典 -->
    <el-dialog
      :title="dictStates[dictState]"
      :visible.sync="showDialog"
      width="400px"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="dict"
          ref="userForm"
          :rules="rules"
          label-width="80px"
          size="mini"
        >
          <el-form-item
            label="类型"
            prop="dictType"
          >
            <el-input
              :disabled="dictState == 'check'"
              placeholder="类型"
              v-model="dict.dictType"
              size="small"
              style="width:200px"
            ></el-input>
          </el-form-item>

          <el-form-item
              label="名称"
              prop="dictName"
          >
            <el-input
              :disabled="dictState == 'check'"
              placeholder="名称"
              :rows="1"
              v-model="dict.dictName"
              size="small"
              style="width:200px"
            ></el-input>
          </el-form-item>

            <el-form-item
                label="备注"
            >
                <el-input
                    style="width: 200px"
                    :disabled="dictState == 'check'"
                    type="textarea"
                    placeholder="备注"
                    :rows="3"
                    v-model="dict.remarks"
                    size="small"
                ></el-input>
            </el-form-item>

            <el-form-item
                label="状态"
                prop="status"
            >
                <el-select
                    style="width:200px"
                    v-model="dict.status"
                    size="small"
                    placeholder="请选择"
                    :disabled="dictState == 'check'"
                >
                    <el-option
                        label="正常"
                        :value="1"
                    > </el-option>
                    <el-option
                        label="禁用"
                        :value="0"
                    > </el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item
            label="配置"
            prop="isShow"
            >
                <el-select
                    style="width:200px"
                    v-model="dict.isShow"
                    size="small"
                    placeholder="请选择"
                    :disabled="dictState == 'check'"
                >
                    <el-option
                        label="显示"
                        :value="1"
                    > </el-option>
                    <el-option
                        label="隐藏"
                        :value="0"
                    > </el-option>
                </el-select>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input
              :disabled="dictState == 'check'"
              placeholder="排序"
              v-model="dict.sort"
              size="small"
              style="width:200px"
            ></el-input>
          </el-form-item>

        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="dictState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
    <!-- 管理字典键值 -->
    <div class="drawer-class">
      <el-drawer
        :title="'数据字典值列表，所属类型: ' + this.currentDictType"
        :visible.sync="showDrawer"
        size="75%"
        direction="rtl"
        @close="closeDrawer"
      >
        <div style="padding: 10px ">
          <el-button
            class="button-class"
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addDictValue"
          >新建</el-button>
        </div>

        <el-table
          size="small"
          :data="dictValueList"
          height="90%"
          element-loading-background="rgba(245, 245, 245, 0.3)"
          @selection-change="handleSelectionChange"
        >

          <el-table-column
            align="center"
            prop="dataValue"
            label="键值"
            width="150"
          > </el-table-column>
          <el-table-column
            align="center"
            prop="dataLabel"
            label="标签"
            width="200"
          > </el-table-column>
          <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                label="名称"
                width="150"
                prop="dataName"
          >
          </el-table-column>
          <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                label="备注"
                width="150"
                prop="remarks"
          >
          </el-table-column>
          <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                label="类型"
                width="80"
                prop="dataType"
          >
          <template slot-scope="scop">
            {{getDictDateTypeOne(scop.row.dataType)}}
          </template>
          </el-table-column>
          <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                label="来源"
                width="110"
                prop="dataSource"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序"
            width="160"
          >
            <template slot-scope="scop">
              <el-input-number
                v-model="scop.row.sort"
                @change="changeValueSort(scop.row)"
                size="small"
                label=""
                :min="1"
                :max="1000"
                :step="1"
                :controls="true"
                controls-position="both"
              >
              </el-input-number>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            prop="status"
            label="状态"
			width="100"
          >
            <template slot-scope="scop">
              <el-tag
                type="danger"
                size="small"
                effect="plain"
                v-if="scop.row.status == '0'"
              >禁用</el-tag>
              <el-tag
                type="success"
                size="small"
                effect="plain"
                v-if="scop.row.status == '1'"
              >正常</el-tag>
            </template>
          </el-table-column>
		  
		  <el-table-column
		    align="center"
		    prop="status"
		    label="配置"
			width="100"
		  >
		    <template slot-scope="scop">
		      <el-tag
		        type="danger"
		        size="small"
		        effect="plain"
		        v-if="scop.row.isShow == '0'"
		      >隐藏</el-tag>
		      <el-tag
		        type="success"
		        size="small"
		        effect="plain"
		        v-if="scop.row.isShow == '1'"
		      >显示</el-tag>
		    </template>
		  </el-table-column>
		  
          <el-table-column
            fixed="right"
            align="center"
            label="操作"
            width="180"
          >
            <template slot-scope="scop">
              <div class="operation">
                <div @click="checkDictValue(scop.row.id)">
                  <Icon size="16">
                    <Eye24Regular />
                  </Icon>
                  <span class="operation-label" >查看</span>
                </div>

                <div @click="editDictValue(scop.row.id)">
                  <Icon size="16">
                    <Edit24Regular />
                  </Icon>
                  <span class="operation-label" >修改</span>
                </div>
                <div @click="deleteValue(scop.row.id)">
                  <Icon
                    size="16"
                    style="color: red"
                  >
                    <Delete24Regular />
                  </Icon>
                  <span class="operation-label"  style="color: red">删除</span>
                </div>

              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-drawer>
    </div>
    <!-- 新增/查看/修改键值内容 -->
    <el-dialog
      :title="dictValueStates[valueState]"
      :visible.sync="showValueDialog"
      width="400px"
      @close="closeValueDialog"
    >
      <div>
        <el-form
          :model="dictValue"
          ref="valueForm"
          :rules="rules"
          label-width="80px"
          size="mini"
        >
          <el-form-item
            label="键值"
            prop="dataValue"
          >
            <el-input
              style="width: 200px"
              :disabled="valueState == 'check'"
              placeholder="键值"
              v-model="dictValue.dataValue"
              size="small"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="标签"
            prop="dataLabel"
          >
            <el-input
              style="width: 200px"
              :disabled="valueState == 'check'"
              placeholder="标签"
              :rows="1"
              v-model="dictValue.dataLabel"
              size="small"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="名称"
            prop="dataName"
          >
            <el-input
              style="width: 200px"
              :disabled="valueState == 'check'"
              placeholder="名称"
              :rows="1"
              v-model="dictValue.dataName"
              size="small"
            ></el-input>
          </el-form-item>

		  <el-form-item
		    label="备注"
		    prop="remarks"
		  >
		    <el-input
		      style="width: 200px"
		      :disabled="valueState == 'check'"
		      type="textarea"
		      placeholder="备注"
		      :rows="3"
		      v-model="dictValue.remarks"
		      size="small"
		    ></el-input>
		  </el-form-item>

      <el-form-item
            label="类型"
            prop="dataType"
          >
          <el-select
              style="width:200px"
              :disabled="valueState == 'check'"
              v-model="dictValue.dataType"
              size="small"
              placeholder="请选择"
          >
              <el-option
                  v-for="(item,index) in dictDateTypeEnumList"
                  :key="index"
                  :label="item.value"
                  :value="item.key"
              > </el-option>
          </el-select>
          </el-form-item>

          <el-form-item
            label="来源"
            prop="dataSource"
          >
            <el-input
              style="width: 200px"
              :disabled="valueState == 'check'"
              placeholder="来源"
              :rows="1"
              v-model="dictValue.dataSource"
              size="small"
            ></el-input>
          </el-form-item>

            
          <el-form-item
            label="状态"
            prop="status"
          >
            <el-select
              style="width: 200px"
              v-model="dictValue.status"
              size="small"
              placeholder="请选择"
              :disabled="valueState == 'check'"
            >
              <el-option
                label="正常"
                :value="1"
              > </el-option>
              <el-option
                label="禁用"
                :value="0"
              > </el-option>
            </el-select>
          </el-form-item>
		  
		  <el-form-item
		      label="配置"
		      prop="isShow"
		  >
		      <el-select
		          style="width:200px"
		          v-model="dictValue.isShow"
		          size="small"
		          placeholder="请选择"
		          :disabled="valueState == 'check'"
		      >
		          <el-option
		              label="显示"
		              :value="1"
		          > </el-option>
		          <el-option
		              label="隐藏"
		              :value="0"
		          > </el-option>
		      </el-select>
		  </el-form-item>
		  
		  
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input-number
              style="width: 200px"
              v-model="dictValue.sort"
              size="medium"
              label="排序"
              :disabled="valueState == 'check'"
              :min="1"
              :max="10000"
              :step="1"
              :controls="true"
              controls-position="both"
            >
            </el-input-number>
          </el-form-item>

        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeValueDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitValueForm"
          v-if="valueState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { get,deleteFun } from '@/utils/request.js';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { ArrowDownload24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, Search } from '@v2icons/tabler';
import {
    getDictList,
    getDictById,
    deleteDict,
    addDict,
    editDict,
    getDictValue,
    findDictValue,
    saveDictValue,
    editDictValue,
} from '@/api/dict.js';

export default {
    name: 'DictTypeListTable',
    components: {
        GridDots,
        Refresh,
        Printer,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        ArrowDownload24Regular,
        Search
    },
    props: {
        checkState: String,
        queryForm: Object,
        resetCheckState: Function,
        resetCheckStates: Function,
    },
    watch: {
        checkState(val) {
            console.log(val);
            if (val == 'check') {
                this.resetDictList();
                this.getDictList(this.queryForm);
            } else if (val == 'reset') {
                this.resetDictList();
                this.getDictList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            dictDateTypeEnumList: [],
            loading: false,
            showDialog: false,
            showValueDialog: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 10,
            currentDictId: '',
            dictState: 'add',
            dictStates: {
                add: '新增字典',
                check: '查看字典',
                edit: '编辑字典'
            },
            valueState: 'add',
            dictValueStates: {
                add: '新增键值',
                check: '查看键值',
                edit: '编辑键值'
            },

            multipleSelection: [],
            dictList: [],
            isSearch: false,
            dict: {
                id: '',
                dictType: '',
                dictName: '',
                isShow: 1,
                status: 0,
                remarks: '',
                mppDictDataList: [],
            },
            rules: {
                dictType: [{ required: true, message: '类型不能为空', trigger: 'blur' }],
                dictName: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
            },
            showDrawer: false,
            dictValueList: [],
            currentValueId: '',
            dictValue: {
                id: '',
                isShow: 1,
                dictId: '',
                dataLabel: '',
                dataValue: '',
                status: 0,
                dataName: '',
                dataType: '',
                dataSource: '',
                sort: "10",
                remarks: ''
            },
            value: {
                dataValue: '',
                dataLabel: '',
                status: 0,
                dataName: '',
                dataType: '',
                dataSource: '',
                sort: '',
                dictId: '',
                remarks: ''
            },
            editValue: {
                id: '',
                dataValue: '',
                dataLabel: '',
                status: 0,
                dataName: '',
                dataType: '',
                dataSource: '',
                sort: 10,
                dictId: ''
            },
            currentDictType: '',
        };
    },
    created() {
        this.getDictList();
        this.getDictDateTypeEnum();
    },
    methods: {

      search(){
        this.isSearch= ! this.isSearch;
        this.$emit('send',this.isSearch);
      },

        resetDictList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.dictList = [];
        },
        resetDialog() {
            this.$refs.userForm.resetFields();
            this.userState = 'add';
            this.showDialog = false;
            this.dict = {};
        },
        closeDialog() {
            this.resetDialog();
        },
        submitForm() {
            if (this.dictState == 'add') {
                this.$refs.userForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        addDict({ ...this.dict }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: '新增字典成功',
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetDictList();
                                this.resetDialog();
                                this.getDictList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.dictState == 'edit') {
                this.$refs.userForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        editDict({ ...this.dict }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: '编辑字典成功',
                                    type: 'success',
                                    duration: 2000
                                });
                                this.$emit('resetCheckStates','kong')
                                this.resetDictList();
                                this.resetDialog();
                                this.getDictList();
                            }
                        });
                    }
                });
            }
        },
        submitValueForm() {
            if (this.valueState == 'add') {
                this.$refs.valueForm.validate((valid) => {
                    if (valid) {
                        this.value.dataValue = this.dictValue.dataValue;
                        this.value.dataLabel = this.dictValue.dataLabel;
                        this.value.remarks = this.dictValue.remarks;
                        this.value.status = this.dictValue.status;
                        this.value.sort = this.dictValue.sort;
                        this.value.isShow = this.dictValue.isShow;
                        this.value.dictId = this.currentDictId;
                        this.value.dataName = this.dictValue.dataName;
                        this.value.dataType = this.dictValue.dataType;
                        this.value.dataSource = this.dictValue.dataSource;
                        saveDictValue({ ...this.value }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: '新增键值成功',
                                    type: 'success',
                                    duration: 2000
                                });
                                this.getDictValueById();
                                this.showValueDialog = true;
                                this.showValueDialog = false;
                                // this.resetDictList();
                                // this.resetDialog();
                                // this.getDictList();
                            }
                        });
                    }
                });
            } else if (this.valueState == 'edit') {
                this.$refs.valueForm.validate((valid) => {
                    if (valid) {
                        this.editValue.id = this.dictValue.id;
                        this.editValue.dataValue = this.dictValue.dataValue;
                        this.editValue.dataLabel = this.dictValue.dataLabel;
                        this.editValue.remarks = this.dictValue.remarks;
                        this.editValue.status = this.dictValue.status;
                        this.editValue.sort = this.dictValue.sort;
                        this.editValue.isShow = this.dictValue.isShow;
                        this.editValue.dictId = this.currentDictId;
                        this.editValue.dataName = this.dictValue.dataName;
                        this.editValue.dataType = this.dictValue.dataType;
                        this.editValue.dataSource = this.dictValue.dataSource;
                        console.log(this.editValue);
                        editDictValue({ ...this.editValue }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: '编辑字典成功',
                                    type: 'success',
                                    duration: 2000
                                });
                                this.getDictValueById();
                                this.showValueDialog = true;
                                this.showValueDialog = false;
                                // this.resetDictList();
                                // this.resetDialog();
                                // this.getDictList();
                            }
                        });
                    }
                });
            }
        },
        addDict() {
            this.showDialog = true;
            this.dictState = 'add';
            this.dict= {
                id: '',
                dictType: '',
                dictName: '',
                isShow: 1,
                status: 1,
                remarks: '',
                mppDictDataList: [],
            }
        },
        addDictValue() {
            //console.log(this.currentDictId);
            this.showValueDialog = true;
            this.valueState = 'add';
            this.dictValue.sort = 10;
            this.dictValue = {
                id: '',
                isShow: 1,
                dictId: '',
                dataLabel: '',
                dataValue: '',
                dataName: '',
                dataType: '',
                dataSource: '',
                status: 1,
                sort: "10",
                remarks: ''
            }
        },
        checkDict(dictId) {
            console.log(dictId);
            this.currentDictId = dictId;
            this.getDictById();
            this.showDialog = true;
            this.dictState = 'check';
        },
        checkDictValue(valueId) {
            //console.log(valueId);
            this.currentValueId = valueId;
            this.showDictValue();
            this.showValueDialog = true;
            this.valueState = 'check';
        },
        editDictValue(valueId) {
            //console.log(valueId);
            this.currentValueId = valueId;
            this.showDictValue();
            this.showValueDialog = true;
            this.valueState = 'edit';
        },
        editDict(dictId) {
            console.log('user', dictId);
            if (dictId) {
                this.currentDictId = dictId;
                this.getDictById();
            } else {
                this.dict = { ...this.dict, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.dictState = 'edit';
        },
        updateDictValue(dictId) {
            this.showDrawer = true;
            this.currentDictId = dictId;
            this.getDictById();
        },
        getDictValue(dictId, dictType) {
            this.showDrawer = true;
            this.currentDictId = dictId;
            this.currentDictType = dictType;
            this.getDictValueById();
        },
        closeDrawer() {
            this.showDrawer = false;
            this.currentDictId = '';
            this.dictValueList = [];
        },
        closeValueDialog() {
            this.showValueDialog = false;
            this.dictValue = {};
        },

        deleteDict(dictId) {
            let ids = '';
            if (dictId) {
                ids = dictId;
            } else {
                ids = this.multipleSelection.map((dict) => dict.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteDict({ str: ids }).then((res) => {
                        console.log({ res });
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                showClose: true,
                                duration: 2000
                            });

                            this.resetDictList();
                            this.getDictList();
                        }
                    });
                })
                .catch(() => {});
        },
        deleteValue(dictValueId) {
            let ids = '';
            if (dictValueId) {
                ids = dictValueId;
            } else {
                ids = this.multipleSelection.map((dictValue) => dictValue.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/dict/deleteValue`, { str: ids }).then((res) => {
                        console.log({ res });
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                showClose: true,
                                duration: 2000
                            });

                            // this.resetDictList();
                            this.getDictValueById();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshDictList() {
            this.resetDictList();
            this.getDictList();
        },
        getDictList(query = {}) {
            this.loading = true;
             console.log('query',query);
            getDictList({ ...query, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.dictList = res.list.list;
                    this.totalNum = res.list.total;
                }
            });
        },
        getDictById() {
            getDictById({ id: this.currentDictId }).then((res) => {
                if (res.success) {
                    this.dict = res.dict;
                }
            });
        },
        getDictValueById() {
            getDictValue({ dictId: this.currentDictId, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                console.log('getDictValue',res);
                if (res.success) {
                    var dictData = res.value;
                    if (dictData.length >= 0) {
                        for (var item = 0; item < dictData.length; item++) {
                            dictData[item]['index'] = item + 1;
                        }
                        this.dictValueList = dictData;
                        // console.log(this.dictValueList)
                    }
                }
            });
        },
        showDictValue() {
            console.log(this.currentValueId);
            findDictValue({ id: this.currentValueId }).then((res) => {
                if (res.success) {
                    this.dictValue = res.value;
                    console.log(res.value);
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getDictList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getDictList();
        },
        changeValueSort(value) {
            console.log(value);
            // if (!menu.parentId) {
            //     delete menu.parentId;
            // }
            // delete menu.children;
            editDictValue({ ...value }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: `编辑成功`,
                        type: 'success',
                        duration: 2000
                    });
                    this.getDictValueById();
                    // this.getLeftMenuList();
                    // this.resetDialog();
                    // this.resetMenuList();
                    // this.getMenuList();
                }
            });
        },

        getDictDateTypeEnum(){
          get('/mpp/utils/getEnum',{enumType: 'dict_data_type'}).then((res)=>{
              if(res.success){
                  this.dictDateTypeEnumList = res.enumList
              }
          })
        },
        getDictDateTypeOne(key){
          for(var i=0;i<this.dictDateTypeEnumList.length;i++){
              if(this.dictDateTypeEnumList[i].key==key){
                  return this.dictDateTypeEnumList[i].value
              }
          }
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
